import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Container } from 'react-bootstrap';
import { useTranslation, Trans } from 'react-i18next';

export default function ImprintScreen() {
  const { t, i18n } = useTranslation();
  const selectedLanguage = i18n.resolvedLanguage;

  return (
    <Container>
      <div className="container small-container">
        <title>{t('imprint-screen-helmet')}</title>

        <h1 className="screen-heading">{t('imprint-screen-heading')}</h1>

        <Row className="text-container">
          <Col>
            <div className="imprint-container">
              <p>
                {t('imprint-screen-imprint-row-1')}
                <br />
                {t('imprint-screen-imprint-row-2')}
                <br />
                {t('imprint-screen-imprint-row-3')}
                <br />
                {t('imprint-screen-imprint-row-4')}
              </p>
            </div>
            <div className="imprint-container">
              <p>
                {t('imprint-screen-imprint-row-6')}
                <br />
                {t('imprint-screen-imprint-row-5')}{' '}
                <a
                  href="https://www.custom-keycaps.com/contact"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: 'underline' }}
                >
                  {t('imprint-screen-imprint-row-5.2')}
                </a>
              </p>
            </div>
            <div className="imprint-container">
              <p>
                {t('imprint-screen-imprint-row-7')}
                <br />
                {t('imprint-screen-imprint-row-8')}
              </p>
            </div>
            <div className="imprint-container">
              <p>
                <Trans
                  i18nKey="imprint-screen-imprint-row-9"
                  components={{
                    1: <wbr />,
                    2: <span style={{ whiteSpace: 'nowrap' }} />,
                  }}
                />
              </p>
            </div>
            <div className="imprint-container">
              <p>
                <Trans
                  i18nKey="imprint-screen-imprint-row-10"
                  components={{
                    1: <wbr />,
                    2: <span style={{ whiteSpace: 'nowrap' }} />,
                  }}
                />
                <br />
                {t('imprint-screen-imprint-row-11')}
              </p>
            </div>
            <div className="imprint-container">
              <p>
                {t('imprint-screen-imprint-row-12')}{' '}
                <a
                  href="https://ec.europa.eu/consumers/odr"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: 'underline' }}
                >
                  https://ec.europa.eu/consumers/odr
                </a>
              </p>
            </div>
            <div className="imprint-container">
              <p>{t('imprint-screen-imprint-row-13')}</p>
            </div>

            {selectedLanguage !== 'de' && (
              <p className="translation-info">
                <i>{t('imprint-screen-translation-info')}</i>
              </p>
            )}
          </Col>
        </Row>
      </div>
    </Container>
  );
}
